import(/* webpackMode: "eager" */ "/opt/build/repo/app/mindaloo/error.tsx");
